package one.healthium.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class FoodQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectByKeyword(`value`: String, mapper: (
    id: Long,
    product: String,
    emoji: String,
    description: String,
    calories: Double,
    fat: Double,
    carbohydrates: Double,
    fiber: Double,
    protein: Double,
    tablespoon: Double?,
    cups: Double?,
    pieces: Double?,
    isLiquid: Long,
  ) -> T): Query<T> = SelectByKeywordQuery(value) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getDouble(4)!!,
      cursor.getDouble(5)!!,
      cursor.getDouble(6)!!,
      cursor.getDouble(7)!!,
      cursor.getDouble(8)!!,
      cursor.getDouble(9),
      cursor.getDouble(10),
      cursor.getDouble(11),
      cursor.getLong(12)!!
    )
  }

  public fun selectByKeyword(value_: String): Query<FoodEntity> = selectByKeyword(value_, ::FoodEntity)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertFood(
    product: String,
    emoji: String,
    description: String,
    calories: Double,
    fat: Double,
    carbohydrates: Double,
    fiber: Double,
    protein: Double,
    tablespoon: Double?,
    cups: Double?,
    pieces: Double?,
    isLiquid: Long,
  ): Long {
    val result = driver.execute(-997_219_186, """
        |INSERT INTO FoodEntity (product, emoji, description, calories, fat, carbohydrates, fiber, protein, tablespoon, cups, pieces, isLiquid)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          var parameterIndex = 0
          bindString(parameterIndex++, product)
          bindString(parameterIndex++, emoji)
          bindString(parameterIndex++, description)
          bindDouble(parameterIndex++, calories)
          bindDouble(parameterIndex++, fat)
          bindDouble(parameterIndex++, carbohydrates)
          bindDouble(parameterIndex++, fiber)
          bindDouble(parameterIndex++, protein)
          bindDouble(parameterIndex++, tablespoon)
          bindDouble(parameterIndex++, cups)
          bindDouble(parameterIndex++, pieces)
          bindLong(parameterIndex++, isLiquid)
        }.await()
    notifyQueries(-997_219_186) { emit ->
      emit("FoodEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAll(): Long {
    val result = driver.execute(-2_084_627_649, """DELETE FROM FoodEntity""", 0).await()
    notifyQueries(-2_084_627_649) { emit ->
      emit("FoodEntity")
    }
    return result
  }

  private inner class SelectByKeywordQuery<out T : Any>(
    public val `value`: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("FoodEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("FoodEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(849_401_983, """
    |SELECT FoodEntity.id, FoodEntity.product, FoodEntity.emoji, FoodEntity.description, FoodEntity.calories, FoodEntity.fat, FoodEntity.carbohydrates, FoodEntity.fiber, FoodEntity.protein, FoodEntity.tablespoon, FoodEntity.cups, FoodEntity.pieces, FoodEntity.isLiquid FROM FoodEntity
    |WHERE product LIKE '%' || ? || '%'
    |LIMIT 20
    """.trimMargin(), mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, value)
    }

    override fun toString(): String = "Food.sq:selectByKeyword"
  }
}
